import {
  HomeLoggedStyle,
  LogoutButton,
  ProfilePic,
  SesiImage,
  WelcomeRow,
  WrapContent,
  WrapWelcome,
} from "../../styles/HomeLogged";
import SESI from "../../assets/img/sesi.png";
import PROFILEPIC from "../../assets/img/profilePic.jpg";
import ButtonGrid from "../../components/Grid_buttons";
import { FaCog, FaExchangeAlt, FaHome, FaRegThumbsDown } from "react-icons/fa";
import { CiCircleCheck } from "react-icons/ci";
import { IoMdPersonAdd } from "react-icons/io";
import { IoNewspaperOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import {
  ADDADHERENSE,
  ADHERENSEHISTORY,
  AGREEMENTHISTORY,
  ATTINFOS,
  CANCELPLANS,
  CANCELREQUEST,
  ENTERPRISEREGISTER,
  MYCONTRACTS,
  PLANCHANGEVALIDATION,
  VALIDATION,
} from "../../core/app-urls";
import { FiLogOut } from "react-icons/fi";
import { CgProfile } from "react-icons/cg";
import { IoMdPaper } from "react-icons/io";
import { AiOutlineHistory } from "react-icons/ai";
import { RiChatDeleteLine, RiReservedLine } from "react-icons/ri";

export default function HomeLogged() {
  const navigate = useNavigate();

  let pj: String;
  if (localStorage.getItem("person_type") === "CNPJ") {
    pj = "s";
  } else {
    pj = "n";
  }

  const PJbuttons = [
    {
      label: "Cadastro da empresa",
      icon: <FaHome size={20} />,
      onClick: () => navigate(ENTERPRISEREGISTER),
    },
    {
      label: "Inclusão de Adesões",
      icon: <IoMdPersonAdd size={35} />,
      onClick: () => navigate(ADDADHERENSE),
    },
    {
      label: "Validação de Adesões",
      icon: <CiCircleCheck size={35} />,
      onClick: () => navigate(VALIDATION),
    },
    {
      label: "Histórico de Adesões",
      icon: <IoNewspaperOutline size={35} />,
      onClick: () => navigate(ADHERENSEHISTORY),
    },
    {
      label: "Desativar planos",
      icon: <FaRegThumbsDown size={30} />,
      onClick: () => navigate(CANCELPLANS),
    },
    {
      label: "Solicitações de cancelamento",
      icon: <RiChatDeleteLine size={30} />,
      onClick: () => navigate(CANCELREQUEST),
    },
    {
      label: "Solicitações de alteração",
      icon: <FaExchangeAlt size={30} />,
      onClick: () => navigate(PLANCHANGEVALIDATION),
    },
    {
      label: "Histórico de conveniados",
      icon: <AiOutlineHistory size={30} />,
      onClick: () => navigate(AGREEMENTHISTORY),
    },
    // {
    //   label: "Meus contratos",
    //   icon: <FaCog size={20} />,
    //   onClick: () => alert("Configurações"),
    // },
  ];

  const PFbuttons = [
    {
      label: "Atualização cadastral",
      icon: <CgProfile size={30} />,
      onClick: () => navigate(ATTINFOS),
    },
    {
      label: "Contratos e Adesão",
      icon: <IoMdPaper size={35} />,
      onClick: () => navigate(MYCONTRACTS),
    },
    // {
    //   label: "Reserva",
    //   icon: <RiReservedLine size={35} />,
    //   onClick: () => alert("Reserva"),
    // },
  ];

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    navigate("/");
  };

  return (
    <HomeLoggedStyle>
      <WrapContent>
        <LogoutButton onClick={handleLogout}>
          <FiLogOut size={20} />
          Logout
        </LogoutButton>
        <SesiImage src={SESI} />
        <WelcomeRow>
          {pj !== "s" ? <ProfilePic src={PROFILEPIC} /> : <></>}
          <WrapWelcome>
            <h1>Olá, {localStorage.getItem("name")}</h1>
            <h2>Seja bem vindo(a) ao PORTAL DO CLIENTE</h2>
          </WrapWelcome>
        </WelcomeRow>
        {pj === "s" ? <ButtonGrid buttons={PJbuttons} /> : <></>}
        {pj !== "s" ? <ButtonGrid buttons={PFbuttons} /> : <></>}
      </WrapContent>
    </HomeLoggedStyle>
  );
}
